import classNames from 'classnames';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form, Field } from 'redux-form';

import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { RadioButton } from 'common/components/forms';
import { FormError, Button } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateAndChargePayGate } from 'redux/cart/actions';

import PayGateHiddenForm from './PayGateHiddenForm';
import {
  validateAddressForNotLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: 'shipping',
      isSubmitting: false,
      redirect: null
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    this.setState({ isSubmitting: true });
    const data = transformData(form, this.props);
    const cart = props.cart.data;
    const successFunction = (order) => {
      this.setState({ isSubmitting: false });
      props.history.push(
        `/checkout/receipt?orderNumber=${
          order.orderNumber
        }&email=${encodeURIComponent(cart.email)}`
      );
    };
    const redirectFunction = (response) => {
      this.setState({ redirect: response });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    props.updateAndChargePayGate(
      data.address,
      data.creditCard,
      0,
      successFunction,
      redirectFunction,
      errorFunction
    );
  };

  handleBack = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onEdit('shipping');
  };

  handleSameAsBilling = (e) => {
    this.setState({ selectedOption: e.currentTarget.value });
  };

  render() {
    const { cart, handleSubmit, change, form, settings } = this.props;
    const { selectedOption, isSubmitting, redirect } = this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (cart.billTo) {
      object = cart.billTo;
    }
    if (redirect) {
      return <PayGateHiddenForm redirect={redirect} />;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <CreditCardForm />

        <p>&nbsp;</p>
        <h3>Billing address</h3>
        <div className="c7-checkout__content__radio-options-group">
          <Field
            name="isSameAsBillingAddress"
            component={RadioButton}
            label="Same as shipping address"
            onChange={this.handleSameAsBilling}
            type="radio"
            value="shipping"
          />

          <div className="c7-no-border">
            <Field
              name="isSameAsBillingAddress"
              component={RadioButton}
              label="Use a different billing address"
              onChange={this.handleSameAsBilling}
              type="radio"
              value="billing"
            />
          </div>

          <div
            className={classNames(
              selectedOption === 'shipping'
                ? 'c7-checkout__content__radio-options-group__hidden'
                : 'c7-checkout__content__radio-options-group__edit'
            )}
          >
            <AddressForm
              object={object}
              changeFunction={change}
              settings={settings}
            />
          </div>
        </div>

        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete Order
          </Button>
          <a
            href="#"
            aria-label="Return to shipping method"
            onClick={this.handleBack}
          >
            Return to shipping method
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values, props) => {
  let address;
  if (values.isSameAsBillingAddress === 'billing') {
    address = transformAddressData(values);
    address.customerAddressId = values.customerAddressId;
  } else {
    address = props.cart.data.shipTo;
    delete address.id;
  }
  const creditCard = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName
  };
  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  if (values.isSameAsBillingAddress === 'billing') {
    const { address } = transformData(values, props);
    address.birthDay =
      values.birthDay && convertStringToInteger(values.birthDay);
    address.birthMonth =
      values.birthMonth && convertStringToInteger(values.birthMonth);
    address.birthYear =
      values.birthYear && convertStringToInteger(values.birthYear);
    errors = Object.assign(
      errors,
      validateAddressForNotLoggedInCustomer(address, props.settings)
    );
  }
  const { creditCard } = transformData(values, props);
  errors = Object.assign(errors, validateCreditCard(creditCard));
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues = {};
  if (state.cart && state.cart.data) {
    const { billTo } = state.cart.data;
    initialValues = Object.assign(initialValues, initialFormValues(billTo));
    if (!initialValues.countryCode) {
      initialValues.countryCode = getDefaultCountryCode(state.setting);
    }
    initialValues.isSameAsBillingAddress = 'shipping';
  }
  return {
    cart: state.cart,
    customer: state.customer,
    settings: state.setting,
    initialValues
  };
};

Payment = reduxForm({
  form: 'paymentNotLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, { updateAndChargePayGate })(Payment)
);
